<icc-list [searchable]="true" [items]="types"
          [itemTemplate]="'itemImgTitleDescription'"
          itemWidth="full"
          [ignoreTemplateWidth]="true"
          itemImgHeight="medium"
          (select)="selectType($event)"
          [selected] = "selectedTypeId"
          [tabs]="tabs"></icc-list>
